(ns io.daskul.webapp.widgets.form.selector-logic
  "Pure dispatch logic for the selector widget (#863).

   Separates *cardinality* — single vs multiple value — from the widget's other
   variants. A `:lookup` or `:select` with `:mode :multi` is a multi-value field
   and renders the multi-select; the widget name alone no longer decides it. This
   is the F-022 contract the old renderer ignored (it switched on the widget name,
   so `:widget :lookup :mode :multi-select` fell through to a single-select).

   No UI import, so it runs under :node-test — per the webapp-ui convention.")

(def ^:private multi-modes
  "The `:mode` values that make a field hold multiple values. `:multi` is the
   canonical spelling; `:multi-select` is the legacy one F-022 documented."
  #{:multi :multi-select})

(def ^:private own-component-widgets
  "Widgets that ARE their own concrete component regardless of cardinality — they
   render themselves, not the generic single/multi select."
  #{:radio :radio-card :checkbox :segmented :autocomplete})

(defn widget-of
  "The widget keyword, defaulting to `:select`. Config can arrive with a string
   widget (server config → JSON round-trip), so coerce."
  [ui]
  (keyword (or (:widget ui) "select")))

(defn multi?
  "Does this field hold multiple values (a vector) rather than a single one?
   True for the `:multi-select` and `:checkbox` widgets, and for any field flagged
   `:mode :multi` (or legacy `:multi-select`). `:mode` may be a string or keyword."
  [ui]
  (let [widget (widget-of ui)]
    (boolean (or (= widget :multi-select)
                 (= widget :checkbox)
                 (multi-modes (keyword (:mode ui)))))))

(defn render-as
  "Which concrete component the selector should render, as a dispatch keyword.
   Cardinality is decided separately from the widget name: a `:select`/`:lookup`
   with `:mode :multi` renders `:multi-select`; widgets that are their own
   component keep it; everything else is the single `:select`."
  [ui]
  (let [widget (widget-of ui)]
    (cond
      (own-component-widgets widget) widget
      (multi? ui)                    :multi-select
      :else                          :select)))
